import React from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';
import { ReactComponent as svg } from './DeleteIcon.svg';

const DeleteIcon = (props: SvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon
      component={svg}
      viewBox='0 0 20 21'
      sx={{
        margin: '0px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& path': {
          fill: theme.colors?.primary.default,
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};

export default DeleteIcon;
